import { useDispatch } from 'react-redux';
import { openManageCookies } from '../../actions';
import Icon from '../../../../../components/Icon';

const ManageCookiesButton = ({
  label,
  'label-hidden': labelHidden,
  className,
}) => {
  const dispatch = useDispatch();

  return (
    <button
      className={`lgpd-button ${className}`}
      type="button"
      aria-label={labelHidden ? label : undefined}
      title={labelHidden ? label : null}
      onClick={() => {
        dispatch(openManageCookies());
      }}
    >
      <Icon name="cookie" />
      {labelHidden ? null : <span className="label">{label}</span>}
    </button>
  );
};

export default ManageCookiesButton;
